import * as React from "react";
import { CircleCheck, Coffee } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const carouselImages = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/dolce_gusto_compatible_capsules_display.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/tassimo_compatible_pods_assortment.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/premium_coffee_capsules_crema.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/espresso_lungo_cappuccino_capsules.png"];
const flavors = [{
  name: "Espresso",
  description: "Intense et riche en arômes pour un réveil parfait."
}, {
  name: "Lungo",
  description: "Doux et équilibré, idéal pour prolonger le plaisir."
}, {
  name: "Cappuccino",
  description: "Onctueux et gourmand avec une mousse de lait généreuse."
}];
export default function CapsulesCompatiblesDolceGustoTassimo() {
  return;
}